document.addEventListener("DOMContentLoaded", function () {
  // Number of items to display per page
  const itemsPerPage = 6;

  // Get all the list items (content blocks) in the multicolumn section
  const items = document.querySelectorAll(".multicolumn-list__item");

  // Function to show/hide items based on the current page
  function showPage(pageNumber) {
    const startIndex = (pageNumber - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    items.forEach((item, index) => {
      if (index >= startIndex && index < endIndex) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });

    // Remove the "pagination__item--current" class from all links
    const paginationLinks = document.querySelectorAll(".pagination__item");
    paginationLinks.forEach((link) => {
      link.classList.remove("pagination__item--current");
    });

    // Add the "pagination__item--current" class to the selected link
    const selectedLink = document.querySelector(
      `.pagination__item[data-page="${pageNumber}"]`
    );
    if (selectedLink) {
      selectedLink.classList.add("pagination__item--current");
    }
  }

  // Calculate the total number of pages
  const totalPages = Math.ceil(items.length / itemsPerPage);

  // Show the first page by default
  showPage(1);

  // Create the pagination navigation
  const paginationNav = document.createElement("nav");
  paginationNav.classList.add("pagination");
  paginationNav.setAttribute("role", "navigation");

  const paginationList = document.createElement("ul");
  paginationList.classList.add("pagination__list", "list-unstyled");
  paginationList.setAttribute("role", "list");

  // Add previous link
  const previousLink = document.createElement("a");
  previousLink.classList.add("pagination__item");
  previousLink.setAttribute("role", "link");
  previousLink.textContent = "<";
  previousLink.addEventListener("click", function () {
    const currentPage = getCurrentPage();
    if (currentPage > 1) {
      showPage(currentPage - 1);
      scrollToTop();
    }
  });

  paginationList.appendChild(createListItem(previousLink));

  for (let i = 1; i <= totalPages; i++) {
    const link = createPaginationLink(i);
    paginationList.appendChild(createListItem(link));
  }

  // Add next link
  const nextLink = document.createElement("a");
  nextLink.classList.add("pagination__item");
  nextLink.setAttribute("role", "link");
  nextLink.textContent = ">";
  nextLink.addEventListener("click", function () {
    const currentPage = getCurrentPage();
    if (currentPage < totalPages) {
      showPage(currentPage + 1);
      scrollToTop();
    }
  });

  paginationList.appendChild(createListItem(nextLink));

  paginationNav.appendChild(paginationList);

  // Add the pagination navigation to the multicolumn section
  const multicolumnSection = document.querySelector(".multicolumn");
  multicolumnSection.appendChild(paginationNav);

  // Include the CSS file from the asset folder
  const styleLink = document.createElement("link");
  styleLink.rel = "stylesheet";
  styleLink.href = "{{ 'component-pagination.css' | asset_url }}";
  document.head.appendChild(styleLink);

  // Helper function to create pagination link
  function createPaginationLink(pageNumber) {
    const link = document.createElement("a");
    link.classList.add("pagination__item");
    link.setAttribute("role", "link");
    link.textContent = pageNumber;
    link.setAttribute("data-page", pageNumber); // Add a data attribute to store the page number
    link.addEventListener("click", function () {
      showPage(pageNumber);
      scrollToTop();
    });
    return link;
  }

  // Helper function to create list item for the pagination link
  function createListItem(link) {
    const listItem = document.createElement("li");
    listItem.appendChild(link);
    return listItem;
  }

  // Helper function to get the current page number
  function getCurrentPage() {
    const currentLink = document.querySelector(".pagination__item--current");
    return parseInt(currentLink.getAttribute("data-page"));
  }

  // Helper function to scroll to the top of the page
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
});
